import { Link } from "@src/components/ui-kit";
import { observer } from "mobx-react-lite";
import type { LinkProps } from "next/link";
import type React from "react";
import { type FC, useEffect, useState } from "react";

export interface OriginColumnProps {
  outgoingInvoice?: { id: string; invoice_no: string } | null;
  originatesBrandCreditAccount?: { id: string; title: string } | null;
}

const Pathname = {
  outgoingInvoice: "/invoices/outgoing-invoices/detail?id=",
  originatesBrandCreditAccount: "/credit-accounts/detail?id=",
};

export const OriginColumn: FC<React.PropsWithChildren<OriginColumnProps>> =
  observer(function OriginColumn(props) {
    const [pathname, setPathname] = useState("#");
    const [title, setTitle] = useState("");

    useEffect(() => {
      const { outgoingInvoice, originatesBrandCreditAccount } = props;

      if (outgoingInvoice) {
        setPathname(Pathname.outgoingInvoice + outgoingInvoice.id);
        setTitle(outgoingInvoice.invoice_no);
      } else if (originatesBrandCreditAccount) {
        setPathname(
          Pathname.originatesBrandCreditAccount +
            originatesBrandCreditAccount.id,
        );
        setTitle(originatesBrandCreditAccount.title);
      }
    }, [props.outgoingInvoice, props.originatesBrandCreditAccount]);

    return (
      // TODO: refactor this cmp so we can use proper type for href
      <Link href={pathname as LinkProps["href"]}>{title}</Link>
    );
  });
